
import loadFetch from '@sfly/uig-cdn-libraries/polyfillFetch';
import loadReact from '@sfly/uig-cdn-libraries/react_16_8';

async function main() {

    await Promise.all([
        loadFetch(),
        loadReact()
    ])
        .then(() => {
            // eslint-disable-next-line
            const MountAPP = require('../App').mount;
            MountAPP();
        })
        .catch((errMsg) => {
            throw new Error(errMsg);
        });
}

main();
